import React from "react";
import { Badge, Alert } from "react-bootstrap";
import { CommonButton, CommonInput } from "../../Input";
import DataTable from "../../table/DataTable";

const Step1ReceiverList = ({ selectedReceivers, onToggleReceiver }) => {
  const mockData = [
    {
      id: "8376",
      name: "SparkMinds",
      contactNo: "--",
      receiverType: "Individual",
      relationship: "Business partner",
      bank: "OMNIPAY, INC.",
      correspondenceBank: "--",
      deliveryMethod: "Bank Transfer",
      createdDate: "06/03/2026 18:37:48",
      status: "--",
    },
  ];

  const columns = [
    { label: "ID", key: "id" },
    {
      label: "Name",
      key: "name",
      render: (item) => <span className="fw-bold text-black">{item.name}</span>,
    },
    { label: "Contact No", key: "contactNo" },
    { label: "Receiver Type", key: "receiverType" },
    { label: "Relationship", key: "relationship" },
    { label: "Bank", key: "bank" },
    { label: "Correspondence Bank", key: "correspondenceBank" },
    { label: "Delivery Method", key: "deliveryMethod" },
    { label: "Created Date", key: "createdDate" },
    { label: "Status", key: "status" },
  ];

  return (
    <>
      <div className="d-flex align-items-center mb-4 gap-2">
        <div style={{ width: "250px" }}>
          <CommonInput placeholder="Enter receiver name" />
        </div>
        <CommonButton
          variant="outline"
          className="p-0 d-flex align-items-center justify-content-center"
          style={{ width: "38px", height: "38px" }}
        >
          <i className="flaticon-381-rotate-1"></i>
        </CommonButton>
        <CommonButton
          className="p-0 d-flex align-items-center justify-content-center"
          style={{
            width: "38px",
            height: "38px",
            backgroundColor: "var(--primary)",
          }}
        >
          <i className="fa fa-search text-white"></i>
        </CommonButton>
      </div>

      <div className="card border-0 shadow-sm rounded-4 mb-4">
        <div className="card-body">
          <DataTable
            columns={columns}
            data={mockData}
            showPagination={false}
            rowClassName={(item) =>
              selectedReceivers.includes(item.id)
                ? "bg-light-blue cursor-pointer"
                : "cursor-pointer"
            }
            onRowClick={(item) => onToggleReceiver(item)}
          />
        </div>
      </div>

      {selectedReceivers.length > 0 && (
        <>
          <Alert
            variant="warning"
            className="py-2 border-0 mb-3"
            style={{
              backgroundColor: "#FFF4E6",
              color: "#B45309",
              fontSize: "11px",
            }}
          >
            <i className="fa fa-info-circle me-2"></i>
            Bank transfer payments made after 6 PM Friday, on weekends, or on
            public holidays will be processed on the next business day.
          </Alert>
          <div className="mb-4">
            <div className="text-muted fs-11 mb-2">Selected beneficiaries</div>
            <div className="d-flex flex-wrap gap-2">
              {selectedReceivers.map((id) => (
                <Badge
                  key={id}
                  bg="light"
                  className="text-black border border-primary px-3 py-2 d-flex align-items-center"
                  style={{ borderRadius: "20px", fontSize: "12px" }}
                >
                  SparkMinds
                  <i
                    className="fa fa-times ms-2 cursor-pointer text-muted"
                    onClick={() => onToggleReceiver({ id })}
                  ></i>
                </Badge>
              ))}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Step1ReceiverList;
